import styled from 'styled-components'

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 15vh;
  z-index: 1000;
`

export const Modal = styled.div`
  background-color: white;
  border-radius: ${props => props.theme.primitives.radius.radius3};
  width: 600px;
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 16px 70px rgba(0, 0, 0, 0.2);
  overflow: hidden;
`

export const Footer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
  border-top: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
  font-size: 12px;
  color: ${props => props.theme.colors.text.subtle};
`

export const FooterHint = styled.span`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`
